import type { Components, Theme } from "@mui/material/styles";
import { outlinedInputClasses } from "@mui/material/OutlinedInput";

export const MuiOutlinedInput: Components<Theme>["MuiOutlinedInput"] = {
  styleOverrides: {
    root: ({ theme }) => ({
      "variants": [
        { props: { size: "small" }, style: { fontSize: theme.typography.pxToRem(14), padding: "8px 12px" } },
        { props: { size: "medium" }, style: { fontSize: theme.typography.pxToRem(16), padding: "10px 12px" } },
      ],
      "borderRadius": 0,
      "backgroundColor": theme.palette.background.paper,
      "& legend": { width: "0px" },

      [`& .${outlinedInputClasses.notchedOutline}`]: {
        border: "1px solid",
        borderColor: theme.palette.grey["400"],
      },

      [`&.${outlinedInputClasses.root}.Mui-disabled fieldset`]: { borderColor: theme.palette.grey["300"] },
      [`&.${outlinedInputClasses.root}:not(.Mui-disabled):hover fieldset`]: {
        border: "1px solid",
        borderColor: theme.palette.primary["500"],
      },
      [`&.${outlinedInputClasses.focused} .${outlinedInputClasses.notchedOutline}`]: {
        borderColor: theme.palette.primary["500"],
      },
      [`&.${outlinedInputClasses.focused}:hover .${outlinedInputClasses.notchedOutline}`]: {
        border: "2px solid",
        borderColor: theme.palette.primary["500"],
      },
    }),
    input: { padding: 0, lineHeight: 1.5 },
  },
};
